// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedFilters-cls1_yLo","cls2":"FeedFilters-cls2_KAh FeedFilters-cls1_yLo"};